export const mediaImportState = $state({
    seed: null,
});

export function setMediaImportSeed(seed) {
    mediaImportState.seed = seed;
}

export function clearMediaImportSeed() {
    mediaImportState.seed = null;
}
